<template>
	<TabSetLayout class="kr-tab-set"
		:disabled="disabled"
		:tabs="tabs"
	/>
</template>

<script>
import {
	EventsMixin,
	makeTab
} from "@teaming/common-ui";

import TabSetLayout from "../Common/TabSetLayout";

export const TAB_DETAILS = "details";
export const TAB_ACTIVITY = "activity";

export default {
	name: "GoalTabSet",
	mixins: [ EventsMixin, ],
	components: {
		TabSetLayout,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		activeTab: {
			type: String,
			default: TAB_DETAILS,
			validator( value ) {
				return [
					TAB_DETAILS,
					TAB_ACTIVITY,
				].includes( value );
			},
		},
		/** [ tabId1, tabId2, ... ] */
		disabledTabs: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		/** [ { id:String, label:String, isActive:Boolean, disabled:Boolean, [count:Number], }, ... ] */
		tabs() {
			const {
				translate,
				activeTab,
				disabled,
				disabledTabs,
			} = this;

			return [
				makeTab( {
					id: "details",
					label: translate( "detailsLabel" ),
					isActive: activeTab === TAB_DETAILS,
					disabled: disabled || disabledTabs.includes( TAB_DETAILS ),
				} ),
				makeTab( {
					id: "activity",
					label: translate( "activityLabel" ),
					isActive: activeTab === TAB_ACTIVITY,
					disabled: disabled || disabledTabs.includes( TAB_ACTIVITY ),
				} ),
			];
		},
	},
	methods: {
		translate( key ) {
			return this.$t( `common-gokr.components.KRTabSet.${ key }` );
		},
	},
};
</script>

<style lang="scss" scoped></style>
